/* eslint-disable no-nested-ternary */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/button-has-type */
/* eslint-disable no-console */
import React, {useEffect, useRef, useState} from 'react'
import Image from 'next/image'
import theme from 'src/themes/theme'
import FileDownloadLineIcon from 'remixicon-react/FileDownloadLineIcon'
import {useWindowSize, useClickAway} from 'react-use'
import {useUser} from 'src/context/UserContext'
import {restApi} from 'src/api/rest'
import Loader from 'src/components/common/Loader'
import {H5} from 'src/components/typography/index'
import {Button} from 'src/components/buttons'
import {formatNumber} from 'src/utils/numbers'
import {palette} from 'styled-tools'
import styled from 'styled-components'
import {Col, media, Row} from 'styled-bootstrap-grid'
import {theme as Theme} from 'src/themes'
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css'
import 'react-calendar/dist/Calendar.css'
import {monthNames} from 'src/const'

const OrdersContainer = styled.div`
  position: relative;
  margin-left: 80px;
  @media (max-width: 750px) {
    margin: 0px;
  }
  .orders-conatiner {
    margin-top: 30px;
    background-color: ${theme.palette.white};
    border-radius: 0px 5px 5px 5px;
    padding: 40px;
    padding-bottom: 80px;
    @media (max-width: 750px) {
      padding: 0px;
    }
  }
  .heading-sort {
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: 768px) {
      flex-direction: column;
      gap: 10px;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
  .download-button {
    background-color: transparent;
    border: none !important;
    :hover {
      svg {
        color: ${theme.palette.error};
      }
    }
    :active {
      svg {
        color: ${theme.palette.error};
      }
    }
  }
  .column {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      padding-right: 5px;
      padding-left: 5px;
    }
    .loader {
      margin: 0px 0px;
      height: 35px;
      @media screen and (max-width: 768px) {
        height: 25px;
      }
    }
  }
  .align {
    width: 100%;
    word-wrap: break-word;
    @media screen and (max-width: 768px) {
      font-size: 12px;
    }
  }
  .orders-table {
    background-color: ${theme.palette.white};
    border: 1px solid ${theme.palette.black20};
    padding: 0px 20px;
    border-radius: 5px 5px 0px 0px;
    @media (max-width: 750px) {
      padding: 0px 10px;
    }
  }
  .header {
    font-size: 600;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      font-size: 12px;
    }
  }
  .row {
    border-bottom: 1px solid ${theme.palette.black20};
    padding-bottom: 15px;
    padding-top: 15px;
  }
  .table-row {
    cursor: pointer;
    :hover {
      color: ${palette('error')};
    }
  }
  .message_box {
    margin: auto;
    padding: 10px;
    font-size: 20px;
    color: ${theme.palette.red};
  }
  .load_button {
    float: right;
    margin-top: 35px;
    margin-right: 10px;
  }
  .loader {
    margin-top: 30px;
    margin-left: 30px;
  }
`

export const SortDropdown = styled.div`
  padding: 3px 6px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 99;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${palette('white')};
  border-radius: 5px;
  border: 2px solid ${palette('black')};
  .sort-button {
    background-color: transparent;
    border: none !important;
    outline: none !important;
    width: 100%;
    min-width: 300px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
      font-size: 16px;
      flex-grow: 1;
      display: flex;
      justify-content: flex-start;
      font-weight: 500;
    }
  }

  .options {
    width: 100%;
    position: absolute;
    top: 45px;
    z-index: 99;
    border: 2px solid ${palette('black')};
    background-color: ${palette('white')};
    ${media.lg`
      position: relative;
      top: 0;
      border-top: border-top: 1px solid ${palette('black')};
      border-bottom: none !important;
      border-left: none !important;
      border-right: none;
    `}
    li {
      padding: 5px;
      button {
        width: 100%;
        text-align: left;
        background-color: transparent;
        border: none !important;
        font-size: 16px;
        &:hover {
          color: ${Theme.palette.error};
        }
        .selected {
          button {
            color: ${Theme.palette.error};
          }
        }
      }
      &:hover {
        cursor: pointer;
      }
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    position: relative;
  }
  align-self: flex-end;
  margin-bottom: 10px;
  .arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
  }
  .up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }
  .down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }

  .sort-calendar-icon {
    margin-right: 10px;
  }
`

type ValuePiece = Date | null

type Value = ValuePiece | [ValuePiece, ValuePiece]

type Filters =
  | 'new'
  | 'old'
  | 'this_month'
  | 'last_month'
  | 'last_three_months'
  | 'last_six_months'
  | 'this_year'
  | 'last_year'
  | 'all'
  | 'custom_range'

type sortby =
  | 'date_desc'
  | 'date_asc'
  | 'this_month'
  | 'last_month'
  | 'last_three_months'
  | 'last_six_months'
  | 'this_year'
  | 'last_year'
  | 'all'
  | 'custom_range'

interface FetchOrderProps {
  nav_id?: string
  ssn: string
  cursor?: string
  ordersPerPage?: number
  page?: number
  limit?: number
  sortby?: string
  start_date?: string
  end_date?: string
}

interface OrderData {
  ['@odata.etag']: string
  No: string
  Order_No: string
  Amount: number
  Amount_Including_VAT: number
  BillTo_Customer_No: number
  BillTo_Name: string
  Document_Date: string
  Due_Date?: string
  Posting_Date?: string
  Payment_Terms_Code: string
  SellTo_Contact: string
  SellTo_Customer_Name: string
  SellTo_Customer_No: string
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
`

const ModalContent = styled.div`
  background: white;
  padding: 50px;
  min-width: 50%;
  position: relative;

  @media screen and (max-width: 1240px) {
    min-width: 80%;
  }

  .close-button {
    position: absolute;
    border: 1px solid black;
    font-weight: 700;
    top: 0;
    right: 0;
    padding: 15px;
    background-color: #cbcbcb;
  }

  .date-heading {
    font-size: 28px;
    font-weight: 700;
    line-height: 52px;
    letter-spacing: 0em;
    text-align: center;
  }

  .date-section {
    font-weight: 700;
    margin: 10px 0px;
    p {
      margin-bottom: 10px;
    }
    p.date-error-text {
      color: #ef3f57;
      font-weight: normal;
      margin: 10px 0;
    }
  }

  .btns-container {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;

    > button {
      padding: 15px 10px;
      background-color: transparent;
      width: 50%;
      border: 1px solid gray;
      outline: none;
      text-align: center;
      font-weight: 700;
      font-size: 18px;
    }
  }

  .react-date-picker {
    width: 100%;
  }

  .react-date-picker__wrapper {
    padding: 8px;
  }
  .react-date-picker__clear-button {
    display: none;
  }
  .react-date-picker__calendar-button {
    order: 1;
  }
  .react-date-picker__inputGroup {
    order: 2;
  }

  .react-calendar__tile--active {
    background: none;
    border: 1px solid red;
    color: red;
    border-radius: 5px;
  }

  .react-calendar__tile--active:enabled:hover {
    background: #cbcbcb;
  }

  .react-calendar__month-view__days__day--weekend {
    color: black;
  }

  button:disabled {
    opacity: 0.7;
    background: #cbcbcb;
    cursor: not-allowed;
  }
`

const options: Record<Filters, string> = {
  new: 'Nýjast',
  old: 'Elst',
  this_month: 'Í þessum mánuði',
  last_month: 'Í síðasta mánuði',
  last_three_months: 'Síðustu 3 mánuðir',
  last_six_months: 'Síðustu 6 mánuðir',
  this_year: 'Þetta ár',
  last_year: 'Síðasta ár',
  all: 'Allt',
  custom_range: 'Velja tímabil',
}

const dateOptions = [
  'this_month',
  'last_month',
  'last_three_months',
  'last_six_months',
  'this_year',
  'last_year',
]

export default function OrdersOverview(): JSX.Element {
  const [data, setData] = useState<OrderData[] | null>()
  const [dwnldPdf, setDwnldPdf] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [showLoad, setShowLoad] = useState<boolean>(true)
  const [error, setError] = useState<string>('Engar pantanir')
  const {user, currentCompany} = useUser()
  const {width} = useWindowSize()

  const [sortBy, setSortBy] = useState<sortby>('all')
  const [sortOpt, setSortOpt] = useState<Filters | string | null>('all')
  const [sortText, setSortText] = useState<string>('Allt')

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [showDropdown, setShowDropdown] = useState<boolean>(false)

  const [startDate, setStartDate] = useState<Value | Date | null>(null)
  const [endDate, setEndDate] = useState<Value | Date | null>(null)

  const [cursor, setCursor] = useState<string | null>()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formatDate = (date: any): string => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const closeModal = (): void => {
    setIsModalOpen(false)
  }

  const getReceipt = (receiptId: string): void => {
    setDwnldPdf(receiptId)

    restApi
      .receiptsPdfRetrieve(receiptId)
      .then((resp) => {
        resp.blob().then((blob) => {
          const fileURL = window.URL.createObjectURL(blob)
          const alink = document.createElement('a')
          alink.href = fileURL
          // alink.target = '_blank'
          alink.download = `${receiptId}.pdf`

          // Append the link to the document (required for Safari)
          document.body.appendChild(alink)
          alink.click()

          // Remove the link from the document after the download
          document.body.removeChild(alink)

          setDwnldPdf('')
        })
      })
      .catch((err) => {
        console.log({err})
        setDwnldPdf(receiptId)
      })
  }

  const fetchOrders = ({
    ssn,
    nav_id,
    sortby,
    start_date,
    end_date,
    // eslint-disable-next-line @typescript-eslint/no-shadow
    cursor,
  }: FetchOrderProps): void => {
    setLoading(true)
    restApi
      .receiptsList({
        ssn,
        nav_id,
        sortby,
        start_date,
        end_date,
        cursor,
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((response: any) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (response.data['@odata.nextLink' as string]) {
          setShowLoad(true)
          const token = response.data['@odata.nextLink'].split('skiptoken=')[1]
          if (token) {
            setCursor(token)
          }
        } else {
          setCursor(null)
          setShowLoad(false)
        }

        setData((prev) => {
          if (!prev || !prev?.length) {
            return response.data.value as OrderData[]
          }
          return [...prev, ...(response.data.value as OrderData[])]
        })
      })
      .then(() => {
        setLoading(false)
      })
      .catch((err) => {
        console.log({err})
        setLoading(false)
      })
  }

  const addQueryParam = (key: string, value: string): void => {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set(key, value)

    // Replace the current URL with the new one containing the updated query parameters
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`
    window.history.replaceState({}, '', newUrl)
  }

  const loadCustomDates = (
    firstDay: string,
    lastDay: string,
    filter: string,
  ): void => {
    setSortBy(filter as sortby)
    setData(null)
    setSortOpt(filter)
    setShowLoad(true)

    if ((currentCompany?.ssn || user?.verified.ssn) && firstDay && lastDay) {
      fetchOrders({
        ssn: currentCompany?.ssn || user?.verified.ssn || '',
        nav_id: currentCompany?.navId,
        sortby: 'custom_range',
        start_date: firstDay,
        end_date: lastDay,
      })
      setIsModalOpen(false)
    }

    if (filter === 'custom_range') {
      const text = `Allt: ${(startDate as Date)?.getDate()} ${
        (startDate as Date) && monthNames[(startDate as Date)?.getMonth()]
      } ${(startDate as Date)?.getFullYear()} - ${(endDate as Date)?.getDate()} ${
        endDate && monthNames[(endDate as Date)?.getMonth()]
      } ${(endDate as Date)?.getFullYear()}`

      setSortText(text as string)
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const getQueryParam = (key: string) => {
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get(key)
  }

  const loadDates = (filter: string): void => {
    addQueryParam('sortby', filter as string)

    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = currentDate.getMonth() + 1

    const dateText = (firstDay: Date, lastDay: Date): string =>
      `Allt: ${firstDay.getDate()} ${
        monthNames[firstDay.getMonth()]
      } ${firstDay.getFullYear()} - ${lastDay.getDate()} ${
        monthNames[lastDay.getMonth()]
      } ${lastDay.getFullYear()}`

    if (filter === 'this_month') {
      const firstDay = new Date(year, month - 1, 1)
      const lastDay = new Date(year, month, 0)

      setStartDate(firstDay)
      setEndDate(lastDay)

      loadCustomDates(formatDate(firstDay), formatDate(lastDay), filter)

      const text = dateText(firstDay, lastDay)

      setSortText(text as string)
    } else if (filter === 'last_month') {
      const previousMonth = month === 1 ? 12 : month - 1
      const previousYear = month === 1 ? year - 1 : year
      const firstDay = new Date(previousYear, previousMonth - 1, 1)

      const lastDay = new Date(year, month - 1, 0)

      setStartDate(firstDay)
      setEndDate(lastDay)

      loadCustomDates(formatDate(firstDay), formatDate(lastDay), filter)

      const text = dateText(firstDay, lastDay)

      setSortText(text as string)
    } else if (filter === 'last_three_months') {
      const firstDateOfCurrentMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1,
      )
      const firstDay = new Date(firstDateOfCurrentMonth)
      firstDay.setMonth(firstDateOfCurrentMonth.getMonth() - 3)

      const lastDay = new Date(firstDateOfCurrentMonth)
      lastDay.setDate(lastDay.getDate() - 1)

      setStartDate(firstDay)
      setEndDate(lastDay)

      const text = dateText(firstDay, lastDay)

      setSortText(text as string)

      loadCustomDates(formatDate(firstDay), formatDate(lastDay), filter)
    } else if (filter === 'last_six_months') {
      const firstDateOfCurrentMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1,
      )
      const firstDay = new Date(firstDateOfCurrentMonth)
      firstDay.setMonth(firstDateOfCurrentMonth.getMonth() - 6)
      const lastDay = new Date(firstDateOfCurrentMonth)
      lastDay.setDate(lastDay.getDate() - 1)

      setStartDate(firstDay)
      setEndDate(lastDay)

      const text = dateText(firstDay, lastDay)

      setSortText(text as string)

      loadCustomDates(formatDate(firstDay), formatDate(lastDay), filter)
    } else if (filter === 'this_year') {
      const currentYear = currentDate.getFullYear()
      const firstDay = new Date(currentYear, 0, 1)
      const lastDay = new Date(currentYear, 11, 31)

      setStartDate(firstDay)
      setEndDate(lastDay)

      const text = dateText(firstDay, lastDay)

      setSortText(text as string)

      loadCustomDates(formatDate(firstDay), formatDate(lastDay), filter)
    } else if (filter === 'last_year') {
      const currentYear = currentDate.getFullYear()
      const previousYear = currentYear - 1

      const firstDay = new Date(previousYear, 0, 1)

      // Get the ending date of the previous year
      const lastDay = new Date(previousYear, 11, 31)

      setStartDate(firstDay)
      setEndDate(lastDay)

      const text = dateText(firstDay, lastDay)

      setSortText(text as string)

      loadCustomDates(formatDate(firstDay), formatDate(lastDay), filter)
    }

    setShowDropdown(false)
  }

  useEffect(() => {
    // orders made as user
    setData(null)

    if (getQueryParam('sortby') && getQueryParam('sortby') !== 'all') {
      loadDates(getQueryParam('sortby') as string)
      return
    }

    if (!currentCompany && user?.verified.ssn) {
      // eslint-disable-next-line consistent-return
      return fetchOrders({
        ssn: user?.verified.ssn,
        sortby: 'all',
      })
    }
    if (currentCompany?.ssn) {
      // eslint-disable-next-line consistent-return
      return fetchOrders({
        ssn: currentCompany?.ssn,
        nav_id: currentCompany?.navId,
        sortby: 'all',
      })
    }
    // eslint-disable-next-line consistent-return
    return setError('Ógilt fyrirtæki')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCompany, user])

  const convertDate = (date: string): string => {
    const dataArr = date.split('-')
    if (dataArr.length) {
      const convertedDate = dataArr.reverse().join('/')
      return convertedDate
    }
    return '-'
  }

  const LoadMore = (): void => {
    if (data?.length && (currentCompany?.ssn || user?.verified.ssn)) {
      fetchOrders({
        ssn: currentCompany?.ssn || user?.verified.ssn || '',
        nav_id: currentCompany ? currentCompany.navId : undefined,
        cursor: cursor || undefined,
        end_date:
          sortBy === 'all'
            ? undefined
            : endDate
            ? formatDate(endDate)
            : undefined,
        start_date:
          sortBy === 'all'
            ? undefined
            : startDate
            ? formatDate(startDate)
            : undefined,
        sortby: sortBy || 'all',
      })
    }
  }
  const customRange = (): void => {
    setStartDate(null)
    setEndDate(null)
    setIsModalOpen(true)
  }

  const LoadSort = (sortType: sortby, sort: Filters | string): void => {
    setSortBy(sortType)
    setData(null)
    setSortOpt(sort)
    setSortText(sort)
    setShowLoad(true)
    setShowDropdown(false)
    addQueryParam('sortby', 'all')

    if (
      (currentCompany?.ssn || user?.verified.ssn) &&
      sortType === 'custom_range'
    ) {
      fetchOrders({
        ssn: currentCompany?.ssn || user?.verified.ssn || '',
        nav_id: currentCompany?.navId,
        sortby: sortType,
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
      })
      setIsModalOpen(false)
    } else if (currentCompany?.ssn || user?.verified.ssn) {
      fetchOrders({
        ssn: currentCompany?.ssn || user?.verified.ssn || '',
        nav_id: currentCompany?.navId,
        sortby: sortType,
      })
    }
  }
  const SortContainer = (): JSX.Element => {
    const dropDownRef = useRef(null)

    useClickAway(dropDownRef, () => {
      setShowDropdown(false)
    })
    return (
      <SortDropdown ref={dropDownRef}>
        <button
          type="button"
          className="sort-button"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <span>
            <img
              src="/icons/sortCalendarIcon.svg"
              alt="calendar Icon"
              width={16}
              height={16}
              className="sort-calendar-icon"
            />
            {sortText}
          </span>
          <i className={showDropdown ? 'arrow up' : 'arrow down'} />
        </button>
        {showDropdown && (
          <div className="options">
            <ul>
              <li>
                <button
                  type="button"
                  onClick={() => LoadSort('all', 'Allt')}
                  className={sortOpt === 'all' ? 'selected' : ''}
                  disabled={
                    getQueryParam('sortby') === 'all' &&
                    sortBy !== 'custom_range'
                  }
                >
                  {options.all}
                </button>
              </li>
              {dateOptions.map((option) => (
                <li>
                  <button
                    type="button"
                    onClick={() => loadDates(option)}
                    className={sortOpt === option ? 'selected' : ''}
                    disabled={getQueryParam('sortby') === option}
                  >
                    {options[option as Filters]}
                  </button>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  onClick={customRange}
                  className={sortOpt === 'custom_range' ? 'selected' : ''}
                >
                  {options.custom_range}
                </button>
              </li>
            </ul>
          </div>
        )}
      </SortDropdown>
    )
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Modal = ({isOpen, onClose, children}: any): JSX.Element | null => {
    if (!isOpen) return null
    return (
      <ModalOverlay onClick={onClose}>
        <ModalContent onClick={(e) => e.stopPropagation()}>
          {children}
        </ModalContent>
      </ModalOverlay>
    )
  }

  return (
    <OrdersContainer>
      <div className="heading-sort">
        <H5>Reikningar</H5>
        <SortContainer />
      </div>
      <div className="orders-conatiner">
        {loading && !data?.length ? (
          <div className="loader">
            <Loader />
          </div>
        ) : (
          <>
            {data && data.length ? (
              <>
                <div className="orders-table">
                  <Row className="row">
                    <Col col={width > 750 ? 2 : 3} className="column header">
                      <div className="align">Pöntun</div>
                    </Col>
                    {width > 750 && (
                      <Col col={2} className="column header">
                        <div className="align">Dagsetning</div>
                      </Col>
                    )}
                    <Col col={width > 750 ? 3 : 4} className="column header">
                      <div className="align">Nafn viðskiptavinar</div>
                    </Col>
                    <Col col={width > 750 ? 3 : 4} className="column header">
                      <div className="align">Samtals með VSK</div>
                    </Col>
                    <Col col={1} className="column header">
                      <div className="align" />
                    </Col>
                  </Row>
                  <>
                    {data.map((order: OrderData) => (
                      <Row key={order.No} className="row table-row">
                        <Col col={width > 750 ? 2 : 3} className="column">
                          <div className="align">{order.Order_No}</div>
                        </Col>
                        {width > 750 && (
                          <Col col={width > 750 ? 2 : 4} className="column">
                            <div className="align">
                              {convertDate(order.Document_Date)}
                            </div>
                          </Col>
                        )}
                        {/* {width > 750 && ( */}
                        <Col col={width > 750 ? 3 : 4} className="column">
                          <div className="align">
                            {order.SellTo_Customer_Name}
                          </div>
                        </Col>
                        <Col col={width > 750 ? 3 : 4} className="column">
                          <div className="align">
                            {`${formatNumber(
                              Number(order.Amount_Including_VAT),
                            )} kr.`}
                          </div>
                        </Col>
                        <Col col={1} className="column">
                          {dwnldPdf !== order.No ? (
                            <button
                              className="download-button"
                              type="button"
                              onClick={() => getReceipt(order.No)}
                            >
                              <FileDownloadLineIcon
                                size={width > 750 ? 30 : 20}
                              />
                            </button>
                          ) : (
                            <div className="loader">
                              <Loader />
                            </div>
                          )}
                        </Col>
                      </Row>
                    ))}
                  </>
                </div>
                {loading && (
                  <div className="loader">
                    <Loader />
                  </div>
                )}
                {showLoad && (
                  <div className="load_button">
                    <Button
                      onClick={LoadMore}
                      disabled={loading}
                      withGutter
                      outlined
                    >
                      Hlaða meira
                    </Button>
                  </div>
                )}
              </>
            ) : (
              <div className="message_box">{error}</div>
            )}
          </>
        )}
      </div>

      <div>
        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <h1 className="date-heading">Veldu tímabil</h1>
          <div className="date-section">
            <p>Byrjar á:</p>
            <DatePicker
              calendarIcon={
                <Image
                  src="/icons/calendarIcon.svg"
                  alt="calendar Icon"
                  width={25}
                  height={25}
                  className="calendar-icon"
                />
              }
              onChange={setStartDate}
              value={startDate}
            />
            {startDate && startDate > new Date() && (
              <p className="date-error-text">Þetta tímabil er ógilt</p>
            )}
          </div>
          <div className="date-section">
            <p>Endar á:</p>
            <DatePicker
              calendarIcon={
                <Image
                  src="/icons/calendarIcon.svg"
                  alt="calendar Icon"
                  width={25}
                  height={25}
                  className="calendar-icon"
                />
              }
              onChange={setEndDate}
              value={endDate}
            />
            {startDate && endDate && startDate > endDate && (
              <p className="date-error-text">Þetta tímabil er ógilt</p>
            )}
          </div>
          <div className="btns-container">
            <button onClick={() => setIsModalOpen(false)}>Hætta við</button>
            <button
              disabled={!startDate || !endDate}
              onClick={() =>
                loadCustomDates(
                  formatDate(startDate),
                  formatDate(endDate),
                  'custom_range',
                )
              }
            >
              Áfram
            </button>
          </div>
          <button className="close-button" onClick={closeModal}>
            X
          </button>
        </Modal>
      </div>
    </OrdersContainer>
  )
}
